export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.627 11.174L7.6 13.694H.467A8.427 8.427 0 010 10.947a8.147 8.147 0 018-8.28 7.827 7.827 0 018 7.493 7.826 7.826 0 018-7.493 8.147 8.147 0 018 8.28c0 .944-.157 1.881-.467 2.773H19.267a1.334 1.334 0 00-1.134.653l-2.16 3.587-4.173-6.667a1.333 1.333 0 00-2.173-.12zm7.493 10L20 16.36h10.04c-.147.173-.293.347-.453.507L16.48 30.453a.655.655 0 01-.96 0L2.413 16.867a8.193 8.193 0 01-.453-.507h6.333a1.334 1.334 0 001.04-.493l1.2-1.574 4.32 6.907a1.334 1.334 0 001.134.613 1.334 1.334 0 001.133-.64z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};